const $inject = ['$timeout', 'moment'];

const lbExpiryDate = function ($timeout, moment) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    scope : {
      lbExpiryDate: '<'
    },
    compile: function ($element, $attributes) {
      $attributes.$set('maxlength', 5);
      $attributes.$set('pattern', '[01][0-9]\/[0-9][0-9]');

      return function ($scope, $element, $attributes, controllers) {
        const ngModel = controllers[0];
        const allowExpiredDate = $scope.lbExpiryDate;
        let prevViewValue = '';

        ngModel.$validators.mmyy = function (value) {
          return ngModel.$isEmpty(ngModel.$viewValue) || isValid(value);
        };

        if(!allowExpiredDate) {
          ngModel.$validators.expired = function (value) {
            return isExpired(value);
          };
        }

        $element.on('input', function formatInput () {
          var input = $element.val();

          if (!input) return;

          var element = $element[0];
          var formatted = format(parse(input));

          ngModel.$setViewValue(formatted);
          ngModel.$render();

          setCursorPosition(element, element.selectionEnd);

          prevViewValue = formatted;
        });

        function isValid(number) {
          const pattern = /[01][0-9]\/[0-9][0-9]/;
          return pattern.test(number);
        }

        function isExpired(number) {
          if(number && number.length === 5) {
            const expiryDate = moment(number, 'MM/YY').endOf('month');
            const validDate = moment().endOf('month');
            return expiryDate.isSame(validDate) || expiryDate.isAfter(validDate);
          }

          return false;
        }

        function format(number) {
          if(!number) {
            return number;
          }

          const separator = '/';
          const groupPattern = /(\d{1,2})(\d{1,2})?/;
          const matches = number.match(groupPattern) || [];
          let formatted = matches.slice(1).filter(Boolean).join(separator);

          if(formatted.length === 1 && formatted !== '0' && formatted !== '1') {
            formatted = `0${formatted}${separator}`;
          }

          if(formatted.length === 2 && prevViewValue.length < 2) {
            formatted += separator;
          }

          return formatted;
        }

        function setCursorPosition (element, position) {
          $timeout(function () {
            if (element.setSelectionRange) {
              element.setSelectionRange(position, position)
            } else if (element.createTextRange) {
              var range = element.createTextRange();
              range.move('character', position);
              range.select();
            }
          }, 0)
        }

        function parse (number) {
          if (typeof number !== 'string') return '';
          return number.replace(/[^\d]/g, '');
        }

        function $viewValue () {
          return ngModel.$viewValue;
        }

      }
    }
  }
};

lbExpiryDate.$inject = $inject;

export default lbExpiryDate;



// WEBPACK FOOTER //
// ./src/directives/lbExpiryDate.js